import {
  TextAppearance,
  TextColor,
  TextCustom,
  TextCustomProps,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import React from 'react';

interface LabelWithStockProps {
  label: string;
  stock: number;
}
export const labelNameTextStyle: TextCustomProps = {
  appearance: TextAppearance.label100,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize16,
    lineHeight: TextLineHeight.TextLineHeight20,
    fontWeight: TextWeight.regular,
    color: TextColor.inherit,
  },
};

export const labelStockTextStyle: TextCustomProps = {
  ...labelNameTextStyle,
  style: {...labelNameTextStyle.style, fontSize: TextSize.TextSize10},
};
const LabelWithStock: React.FC<LabelWithStockProps> = (props) => {
  const {label, stock} = props;
  return (
    <div className="label-stock">
      <TextCustom {...labelNameTextStyle}>
        {label}
        <TextCustom {...labelStockTextStyle}>{` (${stock})`}</TextCustom>
      </TextCustom>
    </div>
  );
};

export default LabelWithStock;
